// source/config/leagues.ts
export interface League {
  key: string;
  title: string;
  navTitle: string;
  start: number;
  end: number;
  color: string;
}

const LEAGUES: League[] = [
  {
    key: "premiership",
    title: "PREMIER LEAGUE 2026",
    navTitle: "Premier League",
    start: 0,
    end: 20,
    color: "#8FD4E3",
  },
  {
    key: "championship",
    title: "CHAMPIONSHIP 2026",
    navTitle: "Championship",
    start: 20,
    end: 40,
    color: "#EADED6",
  },
  {
    key: "league-1",
    title: "LEAGUE 1 2026",
    navTitle: "League 1",
    start: 40,
    end: 60,
    color: "#FFCCC2",
  },
  {
    key: "league-2",
    title: "LEAGUE 2 2026",
    navTitle: "League 2",
    start: 60,
    end: 80,
    color: "#FFBC84",
  },
];

export default LEAGUES;
